import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserDetailsState } from '../reducers/user-details.reducer';

export const selectUserDetailsState = createFeatureSelector<UserDetailsState>('userDetails');

export const selectLoading = createSelector(selectUserDetailsState, state => state.loading);

export const selectPending = createSelector(selectUserDetailsState, state => state.pending);

export const selectUser = createSelector(selectUserDetailsState, state => state.user);
